module.exports = __webpack_public_path__ + "img/FairbridgesLogo.ad6bd278.png";